import React from "react";
import Headline from "../components/shared/Headline";
import { Button, Col, Flex, Form, FormInstance, Input, notification, Row, Select, Space } from "antd";
import { mdiFacebook, mdiInstagram, mdiWhatsapp } from "@mdi/js";
import Icon from "@mdi/react";
import ContactUsApi from "../../api-services/contact-us-api.service";
const { TextArea } = Input;

const bannerPath = '/iceholidays-assets/images/contact_us.png';
const breadcrumbs = [
  { title: 'Home' },
  { title: 'Contact Us' }
] 


const validateMessages = {
  required: '${label} is required!',
  types: {
    email: '${label} is not a valid email!',
    number: '${label} is not a valid number!',
  },
  number: {
    range: '${label} must be between ${min} and ${max}',
  },
};


export default class ContactUsPage extends React.Component {
  api = new ContactUsApi;
  contactForm = React.createRef<FormInstance>();

  state = {
    states: []
  }


  componentDidMount() {
    this.api.getStates()
      .then(statesData => {
        this.setState({states: statesData})
      })
      .catch(error => {
        notification.error({ message: 'An error occured while loading states.'});
      });
  }

  submitForm(formValues) {
    this.api.contactInquiry(formValues)
      .then(success => {
        if(success){
          notification['success']({message: "Inquiry sent."});
          this.contactForm.current?.resetFields();
        }
      })
      .catch(error => {
        notification.error({ message: 'An error occured while sending inquiry.'});
      });
  }

  render(){
    return (
      <div id="contact-us-page">
        <Headline bannerImage={bannerPath} breadcrumbs={breadcrumbs} title="contact us"/>
  
        <div id="contact-us-page_body">
          <img src="/iceholidays-assets/images/contact_us_form.png"/>
  
          <div id="contact-us-form">
            <div id="contact-us-form_header">
              <h2>Get in touch</h2>
              <span>Send us your enquiry</span>
            </div>
            <Form
              ref={this.contactForm}
              autoComplete="off"
              layout="vertical"
              variant="filled"
              validateMessages={validateMessages}
              onFinish={(formValues)=>this.submitForm(formValues)}
            >
              <Form.Item label="Enter Name" name="name">
                <Input placeholder="Enter Here" />
              </Form.Item>
  
              <Row gutter={20}>
                <Col span={12}>
                  <Form.Item label="Enter Email" name="email" rules={[{ type: 'email' }]} required>
                    <Input placeholder="Enter Here" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Enter Phone Number" name="phone" required>
                    <Input placeholder="Enter Here" />
                  </Form.Item>
                </Col>
              </Row>
  
              <Form.Item label="Select State" name="state">
                <Select
                    placeholder="Please Select"
                    options={this.state?.states}
                  />
              </Form.Item>
  
              <Form.Item label="Select Area" name="area">
                <Input placeholder="Enter Here" />
              </Form.Item>
  
              <Form.Item label="Select Subject" name="subject">
                <Input placeholder="Enter Here" />
              </Form.Item>
  
              <Form.Item label="Write your message" name="message" required>
                <TextArea rows={4} placeholder="Write Here"/>
              </Form.Item>
  
              <Flex align="center" justify="center">
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Flex>
  
            </Form>
          </div>
        </div>
  
        <div id="contact-us-page_footer">
          <Row gutter={[29, 20]} >
            <Col xs={24} sm={24} lg={12}>
              <div>
                <label>Contact Us</label>
                <span>feedback@gd.my</span>
              </div>
            </Col>
            <Col xs={24} sm={24} lg={12}>
              <div>
                <label>Connect with Us</label>
                <Space size={29}>
                  <a target="_blank" href="https://www.facebook.com/thesignaturetour">
                    <Icon path={mdiFacebook} size={1} />
                  </a>
                  <a target="_blank" href="https://www.instagram.com/thesignaturetours">
                    <Icon path={mdiInstagram} size={1} />
                  </a>
                  <a target="_blank" href="https://wa.me/60128688148">
                    <Icon path={mdiWhatsapp} size={1} />
                  </a>
                </Space>
              </div>
            </Col>
          </Row>
        </div>
    </div>
    );
  }
}